/* eslint-disable no-mixed-operators */
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import "./CardTurnoAgreement.css";
import "./CardTurnoAlerts.css";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import CirculoTildeOk from "../../../assets/images/generico/CirculoTildeOk";

const CardTurnoAgreement = ({ turno }) => {
  const {
    textosState,
  } = useContext(PortalContext);


  return <div className="ptur-card-cardTurno-agreement">
    {/* Confirmado por push, por el boton de la card o por el call center: mismo flag. */}
    {turno?.confirmado && (
      <div className="ptur-alert ptur-button">
        <div className="message c-broccoli">
          <CirculoTildeOk width="20" height="20" />
          <span>Turno confirmado</span>
        </div>
      </div>
    )}
    <div className="ptur-alert ptur-button">
      <Tooltip
        descripcion={textosState.textos.data?.compromisoTurno?.descripcion}
        data={
          <div className="message c-primary">
            <AlertIcon color="var(--color-primary)" />
            <span>
              Tu compromiso reservando turnos
            </span>
          </div>
        }
        customCss="tooltip-max"
      />
    </div>
  </div>;
};

export default CardTurnoAgreement;
